import axiosRequest from '@/utils/request'

// 个人信息
export const personInfo = (params) => {
  return axiosRequest({
    url: '/me/person-info',
    method: 'get',
    params
  })
}
// 更改支付密码
export const updatePayPassword = (data) => {
  return axiosRequest({
    url: '/me/update-pay-password',
    method: 'post',
    data
  })
}
// 校验支付密码
export const verifyPayPassword = (data) => {
  return axiosRequest({
    url: '/me/verify-pay-password',
    method: 'post',
    data
  })
}
// 校验用户生日
export const checkBirthday = (params) => {
  return axiosRequest({
    url: '/me/check-birthday',
    method: 'get',
    params
  })
}

// 用户注销
export const userCancel = (data) => {
  return axiosRequest({
    url: '/user/cancel',
    method: 'post',
    showMessage: false,
    data
  })
}

// 用户注销
export const logoutApi = () => {
  return axiosRequest({
    url: '/wallet/open-logout',
    method: 'post'
  })
}
